export const state = () => ({
  data: [],
  choices: undefined,
});

export const mutations = {
  SET_DATA(state, data) {
    state.data = data;
  },
  CLEAN(state) {
    state.data = [];
    state.choices = [];
  },
  SET_CHOICES(state, choices) {
    state.choices = choices;
  },
};

export const getters = {
  getQuery(state) {
    if (state.data.length) {
      return { documentTypes: state.data };
    }
    return {};
  },
};

export const actions = {
  setData({ commit }, data) {
    commit('SET_DATA', data);
  },
  setDataFromQuery({ commit }, { documentTypes }) {
    if (documentTypes) {
      let parsedData = documentTypes;

      if (!Array.isArray(documentTypes)) {
        parsedData = [documentTypes];
      }

      commit('SET_DATA', parsedData);
    } else {
      commit('SET_DATA', []);
    }
  },
  setChoices({ commit }, { documentTypes }) {
    commit('SET_CHOICES', documentTypes);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
